"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildValidTypeaheadCategories = void 0;
/**
 * Build a category map that looks like:
 *  {
 *    provider_name: {category: 'provider_name', display_text: 'Providers'}
 *    clinical_keywords: {...}
 *  }
 * For use in quickly filtering out typeahead categories in the typeahead
 * API responses that are not specified in the widget config. See KENG-30502,
 * SS was bringing back 'departments' even though that cateogry wasn't specified
 * in the config
 *
 * @param config ServerConfig the config from the server/CS
 * @returns Record<ValidTypeaheadCategory | ValidV8TypeaheadCategory,TypeaheadCategory>
 * @todo this can probably go away once we migrate to V9
 */
const buildValidTypeaheadCategories = (config) => {
    const result = new Set();
    config.params.typeahead_categories.forEach((category) => {
        result.add(category.category);
    });
    return result;
};
exports.buildValidTypeaheadCategories = buildValidTypeaheadCategories;
//# sourceMappingURL=buildValidTypeaheadCategories.js.map